import { Component, OnInit, AfterViewInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { environment } from 'environments/environment';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { DateAdapter } from '@angular/material/core';
import { AbstractControl, FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { LiquidadorService } from 'app/services/liquidador.service';
import { LoginService } from 'app/services/login.service';
import { MatSnackBar } from '@angular/material/snack-bar';
//import { Workbook } from 'exceljs';
const FileSaver = require('file-saver');
import { cuitValidator } from 'app/shared/cuit-validator.directive';
import { MatSort } from '@angular/material/sort';

import { MatDialog } from '@angular/material/dialog';
import { ModalFiltrosExcelComponent } from './modal-filtros-excel/modal-filtros-excel.component';
import { ILiquidacion } from './interfaces/liquidacion.interface';
@Component({
  selector: 'app-liquidador',
  templateUrl: './liquidador.component.html',
  styleUrls: ['./liquidador.component.scss']
})
export class LiquidadorComponent implements OnInit {
  valuesToFilter: any = [];

  filtros: FormGroup;
  obraSocial = new FormControl('');
  estado = new FormControl('');
  razonSocial = new FormControl('', Validators.maxLength(100));
  CUIT = new FormControl('', [Validators.pattern('^[0-9]*$'), Validators.maxLength(11), this.validateCuit]);
  fechaTramiteDesde = new FormControl('');
  fechaTramiteHasta = new FormControl('');
  periodoDesde = new FormControl('');
  periodoHasta = new FormControl('');
  judicializado = new FormControl('');

  minFechaTramite = new Date('Jan 1 2022');
  periodo = [];
  periodoObj = {};
  liquidaciones = [];
  dataSourcePrincipal: any;
  src = [];
  customCollapsedHeight = '50px';
  customExpandedHeight = '50px';
  tabIndex = window.history.state.tabIndex;
  sentFilters = window.history.state.sentFilters;
  obrasSociales: any[] = [];
  offset: number;
  env = environment;

  fcTramiteError = false;
  periodoError = false;

  totalRegistros = 0;
  pageSize = 10;
  currentFilters: any = {};
  sortBy: string = '';
  sortOrder: string = '';
  isLoading = false;
  showSpinner = false;
  dataLoaded = false;
  private readonly spinnerDelayMs = 150;
  private readonly minSpinnerVisibleMs = 300;
  private loadingStartedAt = 0;
  private spinnerShownAt = 0;
  private spinnerDelayTimeout: any;
  private spinnerHideTimeout: any;
  private currentRequestId = 0;
  sortByMap = {
    a: 'obraSocial',
    b: 'razonSocial',
    Periodo: 'periodo',
    d: 'tipoFactura',
    e: 'puntoVenta',
    f: 'nroTramite',
    g: 'importe',
    id: 'id',
    h: 'fechaIngreso',
    i: 'estado',
    j: 'observaciones',
    k: 'cuit',
    l: 'esJudicializado'
  };

  displayedColumnsPrincipal: string[] = [
    'id',
    'a',
    'b',
    'Periodo',
    'Comprobante',
    'g',
    'h',
    'Archivos Adjuntos',
    'Marca de Liquidación',
    'Observaciones'
  ];

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  constructor(
    private dateAdapter: DateAdapter<Date>,
    private router: Router,
    private _liquidadorService: LiquidadorService,
    private getSessionData: LoginService,
    private activatedRoute: ActivatedRoute,
    private _snackBar: MatSnackBar,
    public dialog: MatDialog,
    private cdr: ChangeDetectorRef
  ) {
    this.dataSourcePrincipal = new MatTableDataSource(this.liquidaciones);
    this.dateAdapter.setLocale('en-GB');
  }

  compareDates(a: ILiquidacion, b: ILiquidacion) {
    const fechaA = this.convertToDates(a.h);
    const fechaB = this.convertToDates(b.h);
    return fechaB.getTime() - fechaA.getTime();
  }

  convertToDates(dateString: string) {
    const partes = dateString.split('/');
    const day = parseInt(partes[0], 10);
    const month = parseInt(partes[1], 10) - 1;
    const year = parseInt(partes[2], 10);
    return new Date(year, month, day);
  }

  openModal() {
    const dialogRef = this.dialog.open(ModalFiltrosExcelComponent, {
      width: '700px',
      height: 'auto',
      autoFocus: false,
      data: {
        periodos: this.periodoObj,
        liquidaciones: this.liquidaciones,
        obrasSociales: this.obrasSociales
      }
    });
    dialogRef.componentInstance.closeModal = this.closeModal.bind(this);
  }

  closeModal() {
    this.dialog.closeAll();
  }

  applyFilter(filtersValues) {
    this.filtros.markAllAsTouched();
    if (!this.filtros.valid) {
      this._snackBar.open('Recordá que debes completar los campos correctamente ', 'Cerrar', {
        duration: undefined,
        horizontalPosition: 'center',
        verticalPosition: 'top'
      });

      return;
    }

    var filtersJson = {
      obraSocial: this.filtros.get('obraSocial').value,
      razonSocial: filtersValues.razonSocial?.toUpperCase(),
      CUIT: filtersValues.CUIT,
      estado: this.filtros.get('estado').value,
      fechaTramiteDesde: this.formatDateForBackend(filtersValues.fechaTramiteDesde),
      fechaTramiteHasta: this.formatDateForBackend(filtersValues.fechaTramiteHasta),
      periodoDesde: filtersValues.periodoDesde,
      periodoHasta: filtersValues.periodoHasta,
      judicializado: this.filtros.get('judicializado').value
    };

    this.currentFilters = filtersJson;
    this.loadPage(1);
  }

  formatDateForBackend(date: any): string {
    if (!date) return '';

    let dateObj: Date;

    // Si es un objeto de Angular Material DatePicker
    if (date && typeof date === 'object' && date._d) {
      dateObj = date._d;
    } else if (typeof date === 'string') {
      dateObj = new Date(date);
    } else if (date instanceof Date) {
      dateObj = date;
    } else {
      console.log('Formato de fecha no reconocido:', date, typeof date);
      return '';
    }

    if (isNaN(dateObj.getTime())) {
      console.log('Fecha inválida:', date);
      return '';
    }

    const day = ('0' + dateObj.getDate()).slice(-2);
    const month = ('0' + (dateObj.getMonth() + 1)).slice(-2);
    const year = dateObj.getFullYear();

    return `${day}/${month}/${year}`;
  }

  private startLoading() {
    clearTimeout(this.spinnerDelayTimeout);
    clearTimeout(this.spinnerHideTimeout);

    this.isLoading = true;
    this.showSpinner = false;
    this.loadingStartedAt = Date.now();
    this.spinnerShownAt = 0;

    this.spinnerDelayTimeout = setTimeout(() => {
      if (!this.isLoading) return;
      this.showSpinner = true;
      this.spinnerShownAt = Date.now();
      this.cdr.detectChanges();
    }, this.spinnerDelayMs);
  }

  private stopLoading() {
    clearTimeout(this.spinnerDelayTimeout);

    const hideSpinner = () => {
      this.isLoading = false;
      this.showSpinner = false;
      this.cdr.detectChanges();
    };

    if (!this.showSpinner) {
      hideSpinner();
      return;
    }

    const visibleFor = Date.now() - this.spinnerShownAt;
    const remainingVisibleTime = Math.max(0, this.minSpinnerVisibleMs - visibleFor);

    this.spinnerHideTimeout = setTimeout(() => {
      hideSpinner();
    }, remainingVisibleTime);
  }

  loadPage(page: number) {
    const requestId = ++this.currentRequestId;
    this.startLoading();
    try {
      this.getSessionData.getSessionData().subscribe(
        result => {
          if (requestId !== this.currentRequestId) return;
          let mappedSortBy = '';
          let sortOrder = '';

          if (this.sortBy && this.sortOrder) {
            mappedSortBy = this.sortByMap[this.sortBy] || this.sortBy;
            sortOrder = this.sortOrder.toUpperCase();
          }

          this._liquidadorService
            .getLiquidaciones(result.session_id, this.currentFilters, page, this.pageSize, mappedSortBy, sortOrder)
            .subscribe(
              (response: any) => {
                if (requestId !== this.currentRequestId) return;
                this.liquidaciones = response.data ? response.data : response;
                this.totalRegistros = response.total || 0;

                if (this.liquidaciones && this.liquidaciones.length > 0) {
                  this.dataSourcePrincipal = new MatTableDataSource(this.liquidaciones);
                  this.src = this.liquidaciones;
                } else {
                  this.dataSourcePrincipal = new MatTableDataSource([]);
                  this.src = [];
                }

                if (this.paginator) {
                  this.paginator.length = this.totalRegistros;
                  this.paginator.pageIndex = page - 1;
                }

                this.dataSourcePrincipal.sort = null;
                this.dataSourcePrincipal.sortingDataAccessor = (data: any, sortHeaderId: string) => {
                  return '';
                };
                this.dataSourcePrincipal.filterPredicate = (data: any, filter: string) => true;
                this.stopLoading();
              },
              error => {
                console.error('Error al cargar liquidaciones: HEREE', error);
                this._snackBar.open('Ha ocurrido un error al cargar las liquidaciones', 'Cerrar', {
                  duration: undefined,
                  horizontalPosition: 'center',
                  verticalPosition: 'top'
                });
                if (requestId !== this.currentRequestId) return;
                this.stopLoading();
              }
            );
        },
        error => {
          this._snackBar.open('Ha ocurrido un error al cargar las liquidaciones', 'Cerrar', {
            duration: undefined,
            horizontalPosition: 'center',
            verticalPosition: 'top'
          });
          console.error('Error al cargar liquidaciones: CATCH', error);
        }
      );
    } catch (error) {
      console.error('Error al cargar liquidaciones: TRY-CATCH', error);
    }
  }

  ngAfterViewInit() {
    this.dataSourcePrincipal.sort = null;

    if (this.paginator) {
      if (this.totalRegistros > 0) {
        this.paginator.length = this.totalRegistros;
        this.paginator.pageIndex = 0;
      }

      this.paginator.page.subscribe((event: any) => {
        this.pageSize = event.pageSize;
        this.loadPage(event.pageIndex + 1);
      });
    }

    if (this.sort) {
      this.sort.sortChange.subscribe((event: any) => {
        this.sortBy = event.active;
        this.sortOrder = event.direction;
        this.loadPage(1);
      });
    }
  }

  clear() {
    this.filtros.setValue({
      obraSocial: '',
      estado: '',
      razonSocial: '',
      CUIT: '',
      fechaTramiteDesde: '',
      fechaTramiteHasta: '',
      periodoDesde: '',
      periodoHasta: '',
      judicializado: 0
    });
    this.setTabFilter();
  }

  setOSandStatusValue(event: any): void {
    let value = event.tab.textLabel;
    this.sortBy = '';
    this.sortOrder = '';
    if (value === 'Principal') {
      this.filtros.patchValue({
        obraSocial: '',
        estado: '',
        razonSocial: '',
        CUIT: '',
        fechaTramiteDesde: '',
        fechaTramiteHasta: '',
        mesPeriodoDesde: '',
        anioPeriodoDesde: '',
        mesPeriodoHasta: '',
        anioPeriodoHasta: '',
        judicializado: 0
      });
      this.tabIndex = 0;
    } else if (this.obrasSociales.some(os => os.razon_social === value)) {
      // Si la pestaña seleccionada es una obra social
      this.filtros.patchValue({
        obraSocial: value,
        estado: '',
        razonSocial: '',
        CUIT: '',
        fechaTramiteDesde: '',
        fechaTramiteHasta: '',
        mesPeriodoDesde: '',
        anioPeriodoDesde: '',
        mesPeriodoHasta: '',
        anioPeriodoHasta: '',
        judicializado: 0
      });

      this.tabIndex = this.obrasSociales.findIndex(os => os.razon_social === value) + 1;
    } else if (value === 'Liquidado' || value === 'Ver/Mod Autorización' || value === 'Pendiente') {
      this.filtros.patchValue({
        obraSocial: '',
        estado: value,
        razonSocial: '',
        CUIT: '',
        fechaTramiteDesde: '',
        fechaTramiteHasta: '',
        mesPeriodoDesde: '',
        anioPeriodoDesde: '',
        mesPeriodoHasta: '',
        anioPeriodoHasta: '',
        judicializado: 0
      });
    } else if (value === 'Judicializados') {
      this.filtros.patchValue({
        obraSocial: '',
        estado: '',
        razonSocial: '',
        CUIT: '',
        fechaTramiteDesde: '',
        fechaTramiteHasta: '',
        mesPeriodoDesde: '',
        anioPeriodoDesde: '',
        mesPeriodoHasta: '',
        anioPeriodoHasta: '',
        judicializado: 1
      });
    }

    if (value === 'Pendiente') this.tabIndex = this.offset;
    else if (value === 'Ver/Mod Autorización') this.tabIndex = this.offset + 1;
    else if (value === 'Judicializados') this.tabIndex = this.offset + 2;
    else if (value === 'Liquidado') this.tabIndex = this.offset + 3;
    this.applyFilter(this.filtros.value);
  }

  validarPeriodo(control: AbstractControl): ValidationErrors | null {
    const periodoDesdeControl = control.get('periodoDesde');
    const periodoHastaControl = control.get('periodoHasta');

    if (periodoDesdeControl.value && periodoHastaControl.value) {
      const anioDesde = periodoDesdeControl.value.substring(0, 4);
      const mesDesde = periodoDesdeControl.value.substring(4, 6);

      const anioHasta = periodoHastaControl.value.substring(0, 4);
      const mesHasta = periodoHastaControl.value.substring(4, 6);

      if (anioDesde && mesDesde && anioHasta && mesHasta) {
        let desde = new Date(anioDesde, mesDesde);
        let hasta = new Date(anioHasta, mesHasta);

        if (desde.getTime() > hasta.getTime()) {
          //console.log(desde, hasta)
          return { periodo: true };
        }

        return null;
      }
    }

    return null;
  }

  validarFechaTramite(control: AbstractControl): ValidationErrors | null {
    const desde = control.get('fechaTramiteDesde').value;
    const hasta = control.get('fechaTramiteHasta').value;
    if (desde & hasta) {
      if (desde > hasta) {
        return { fechaTramite: true };
      }
    }

    return null;
  }

  validateCuit(control: AbstractControl): { [key: string]: any } | null {
    let cuit = String(control.value);
    if (!control.value) {
      return null;
    }
    if (cuit.length !== 11) {
      return { cuit: { value: 'El campo CUIT debe tener 11 caracteres.' } };
    }

    let acumulado = 0;
    let digitos = cuit.split('');
    let digito = digitos.pop();

    for (let i = 0; i < digitos.length; i++) {
      acumulado += Number(digitos[9 - i]) * (2 + (i % 6));
    }

    let verif = 11 - (acumulado % 11);
    if (verif === 11) {
      verif = 0;
    } else if (verif === 10) {
      verif = 9;
    }

    return Number(digito) == Number(verif) ? null : { cuit: { value: 'El CUIT ingresado es inválido. ' } };
  }

  ngOnInit(): void {
    this.getSessionData.getAll().subscribe(resp => {
      if (!resp['isLogged']) this.router.navigate(['/login']);

      this.getSessionData.getSessionData().subscribe(result => {
        if (!result['rol'] || result['rol'] != 'ASELIQ') {
          this.router.navigate(['/login']);
        }
        this.getObrasSociales(result.session_id);
      });
    });

    this.activatedRoute.queryParams.subscribe(params => {
      let cuil = '';
      cuil = params['inUse'];
      if (cuil != '' && cuil != undefined) {
        this._snackBar.open('El registro al que intenta acceder está siendo editado por ' + cuil, 'Cerrar', {
          duration: undefined,
          horizontalPosition: 'center',
          verticalPosition: 'top'
        });
      }
    });

    //meses y años para periodos
    const anioActual = new Date().getFullYear();
    const anioDesde = 2022;
    const periodo = [];
    const mesActual = new Date().getMonth() + 1;

    for (let i = anioDesde; i <= anioActual; i++) {
      if (anioActual != i) {
        periodo.push({ mesAnio: 'Enero ' + i + '', value: i.toString() + '01'.toString() });
        periodo.push({ mesAnio: 'Febrero ' + i + '', value: i.toString() + '02'.toString() });
        periodo.push({ mesAnio: 'Marzo ' + i + '', value: i.toString() + '03'.toString() });
        periodo.push({ mesAnio: 'Abril ' + i + '', value: i.toString() + '04'.toString() });
        periodo.push({ mesAnio: 'Mayo ' + i + '', value: i.toString() + '05'.toString() });
        periodo.push({ mesAnio: 'Junio ' + i + '', value: i.toString() + '06'.toString() });
        periodo.push({ mesAnio: 'Julio ' + i + '', value: i.toString() + '07'.toString() });
        periodo.push({ mesAnio: 'Agosto ' + i + '', value: i.toString() + '08'.toString() });
        periodo.push({ mesAnio: 'Septiembre ' + i + '', value: i.toString() + '09'.toString() });
        periodo.push({ mesAnio: 'Octubre ' + i + '', value: i.toString() + '10'.toString() });
        periodo.push({ mesAnio: 'Noviembre ' + i + '', value: i.toString() + '11'.toString() });
        periodo.push({ mesAnio: 'Diciembre ' + i + '', value: i.toString() + '12'.toString() });
      } else {
        if (mesActual >= 1) {
          periodo.push({ mesAnio: 'Enero ' + i + '', value: i.toString() + '01'.toString() });
        }
        if (mesActual >= 2) {
          periodo.push({ mesAnio: 'Febrero ' + i + '', value: i.toString() + '02'.toString() });
        }
        if (mesActual >= 3) {
          periodo.push({ mesAnio: 'Marzo ' + i + '', value: i.toString() + '03'.toString() });
        }
        if (mesActual >= 4) {
          periodo.push({ mesAnio: 'Abril ' + i + '', value: i.toString() + '04'.toString() });
        }
        if (mesActual >= 5) {
          periodo.push({ mesAnio: 'Mayo ' + i + '', value: i.toString() + '05'.toString() });
        }
        if (mesActual >= 6) {
          periodo.push({ mesAnio: 'Junio ' + i + '', value: i.toString() + '06'.toString() });
        }
        if (mesActual >= 7) {
          periodo.push({ mesAnio: 'Julio ' + i + '', value: i.toString() + '07'.toString() });
        }
        if (mesActual >= 8) {
          periodo.push({ mesAnio: 'Agosto ' + i + '', value: i.toString() + '08'.toString() });
        }
        if (mesActual >= 9) {
          periodo.push({ mesAnio: 'Septiembre ' + i + '', value: i.toString() + '09'.toString() });
        }
        if (mesActual >= 10) {
          periodo.push({ mesAnio: 'Octubre ' + i + '', value: i.toString() + '10'.toString() });
        }
        if (mesActual >= 11) {
          periodo.push({ mesAnio: 'Noviembre ' + i + '', value: i.toString() + '11'.toString() });
        }
        if (mesActual >= 12) {
          periodo.push({ mesAnio: 'Diciembre ' + i + '', value: i.toString() + '12'.toString() });
        }
      }
    }
    this.periodoObj = JSON.parse(JSON.stringify(periodo.reverse()));

    this.filtros = new FormGroup(
      {
        razonSocial: this.razonSocial,
        CUIT: this.CUIT,
        obraSocial: this.obraSocial,
        estado: this.estado,
        periodoDesde: this.periodoDesde,
        periodoHasta: this.periodoHasta,
        fechaTramiteDesde: this.fechaTramiteDesde,
        fechaTramiteHasta: this.fechaTramiteHasta,
        judicializado: this.judicializado
      },
      { validators: [this.validarPeriodo, this.validarFechaTramite] }
    );

    this.dataSourcePrincipal = new MatTableDataSource(this.liquidaciones);
    this.dataSourcePrincipal.sort = this.sort;
    this.loadPage(1);
  }

  linkPanel() {
    window.location.href = environment.urlWebSitePhp + 'site/inicio';
  }

  marcarComprobante(id) {
    let tabIndex = this.tabIndex;
    let sentFilters = this.filtros.value;
    this.router.navigate(['marcar-comprobante'], {
      queryParams: { id: id },
      state: { tabIndex, sentFilters }
    });
  }

  /*   exportExcel() {
          if (this.src.length == 0)
              return;
  
          const date = new Date();
          const year = date.getFullYear();
          const month = date.getMonth() + 1;
          const day = date.getDate();
          const hour = date.getHours();
          const minutes = date.getMinutes();
          const seconds = date.getSeconds();
          const workBook = new Workbook();
          const workSheet = workBook.addWorksheet('test');
          const newRow = workSheet.addRow(['CONSULTA DE LIQUIDACIONES']);
          const currentRowIdx = workSheet.rowCount; // Find out how many rows are there currently
          const endColumnIdx = workSheet.columnCount; // Find out how many columns are in the worksheet
          // merge by start row, start column, end row, end column
          workSheet.mergeCells(currentRowIdx, 1, 1, 9);
  
          var cel = newRow.getCell(1);
          cel.alignment = { horizontal: 'center' },
              cel.fill = {
                  type: 'pattern',
                  pattern: 'solid',
                  fgColor: { argb: 'e75300' },
              };
          cel.font = { color: { argb: 'ffffff' }, bold: true }
  
  
          const titles = workSheet.addRow(['Obra Social', 'Razón Social', 'Periodo', 'Comprobante', 'Importe', 'Número de Trámite', 'Fecha de Trámite', 'Marca de Liquidación', 'Observaciones']);
          for (var i = 1; i < 10; i++) {
              cel = titles.getCell(i);
              cel.alignment = { horizontal: 'center' },
                  cel.fill = {
                      type: 'pattern',
                      pattern: 'solid',
                      fgColor: { argb: 'e75300' },
                  };
              cel.font = { color: { argb: 'ffffff' }, bold: true }
          }
  
          this.src.forEach((item) => {
              let comprobante = item.d + ' - ' + item.e.toString() + ' - ' + item.f.toString();
              workSheet.addRow([item.a, item.b, item.c, comprobante, item.g, item.id, item.h, item.i, item.j]);
          });
  
          workSheet.columns.forEach(function (column, i) {
              if (i !== 0) {
                  var maxLength = 0;
                  column["eachCell"]({ includeEmpty: true }, function (cell) {
                      var columnLength = cell.value ? cell.value.toString().length : 10;
                      if (columnLength > maxLength) {
                          maxLength = columnLength;
                      }
                  });
                  column.width = maxLength < 10 ? 10 : maxLength;
              }
          });
  
          let tabName = '';
          switch (this.tabIndex) {
              case 0:
                  tabName = 'principal'
                  break;
              case 1:
                  tabName = 'ase'
                  break;
              case 2:
                  tabName = 'osen'
                  break;
              case 3:
                  tabName = 'ospm'
                  break;
              case 4:
                  tabName = 'pendiente'
                  break;
              case 5:
                  tabName = 'ver mod autorizacion'
                  break;
              case 6:
                  tabName = 'judicializado'
                  break;
              case 7:
                  tabName = 'liquidado'
                  break;
              default:
                  tabName = 'principal'
                  break;
          }
  
          workBook.xlsx.writeBuffer().then((data) => {
              let blob = new Blob([data], {
                  type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
              });
              FileSaver(blob, 'rl_' + tabName + '_' + year + month + day + hour + minutes + seconds + '.xlsx');
          });
      } */

  setTabFilter() {
    if (this.tabIndex > 0 && this.tabIndex <= this.obrasSociales.length) {
      const indiceObraSocial = this.tabIndex - 1; //restamos 1 para acceder a la primer posicion del array de OS. el tabindex 0 es el principal y a partir del 1 comienzan las OS.
      let obraSocial = this.obrasSociales[indiceObraSocial]?.razon_social;

      this.filtros.patchValue({
        obraSocial: obraSocial,
        estado: '',
        razonSocial: '',
        CUIT: '',
        fechaTramiteDesde: '',
        fechaTramiteHasta: '',
        mesPeriodoDesde: '',
        anioPeriodoDesde: '',
        mesPeriodoHasta: '',
        anioPeriodoHasta: '',
        judicializado: 0
      });
    } else if (this.tabIndex == this.offset) {
      this.filtros.patchValue({
        obraSocial: '',
        estado: 'Pendiente',
        razonSocial: '',
        CUIT: '',
        fechaTramiteDesde: '',
        fechaTramiteHasta: '',
        mesPeriodoDesde: '',
        anioPeriodoDesde: '',
        mesPeriodoHasta: '',
        anioPeriodoHasta: '',
        judicializado: 0
      });
    } else if (this.tabIndex === this.offset + 1) {
      this.filtros.patchValue({
        obraSocial: '',
        estado: 'Ver/Mod Autorización',
        razonSocial: '',
        CUIT: '',
        fechaTramiteDesde: '',
        fechaTramiteHasta: '',
        mesPeriodoDesde: '',
        anioPeriodoDesde: '',
        mesPeriodoHasta: '',
        anioPeriodoHasta: '',
        judicializado: 0
      });
    } else if (this.tabIndex === this.offset + 2) {
      this.filtros.patchValue({
        obraSocial: '',
        estado: '',
        razonSocial: '',
        CUIT: '',
        fechaTramiteDesde: '',
        fechaTramiteHasta: '',
        mesPeriodoDesde: '',
        anioPeriodoDesde: '',
        mesPeriodoHasta: '',
        anioPeriodoHasta: '',
        judicializado: 1
      });
    } else if (this.tabIndex === this.offset + 3) {
      this.filtros.patchValue({
        obraSocial: '',
        estado: 'Liquidado',
        razonSocial: '',
        CUIT: '',
        fechaTramiteDesde: '',
        fechaTramiteHasta: '',
        mesPeriodoDesde: '',
        anioPeriodoDesde: '',
        mesPeriodoHasta: '',
        anioPeriodoHasta: '',
        judicializado: 0
      });
    }

    this.applyFilter(this.filtros.value);
  }

  getObrasSociales(sessionID) {
    this._liquidadorService.getObrasSocialesProveedor(sessionID).subscribe((response: any) => {
      this.obrasSociales = response?.data;
      //offset se calcula para saber cual es el tabindex dinamico de los estados. Estos tabindex son un numero mayor a "principal" (tabindex 0) y de todas las obras sociales que haya.
      this.offset = this.obrasSociales.length + 1;
    });
  }
}
